module.exports = __webpack_public_path__ + "img/icon-track-graylight.a9c6050c.svg";